<div id="app">
    <div id="layout">
        @if (!isUnauthorized && !isLoading) {
            <div id="header-container">
                <div id="app-header-container">
                    <app-header></app-header>
                </div>
            </div>
        }

        @if (!isUnauthorized) {
            <div id="breadcrumbs-container">
                <app-breadcrumbs></app-breadcrumbs>
            </div>
        }

        <div id="content">
            @if (isLoading) {
                <div id="app-loader">
                    <loader [global]="true"></loader>
                </div>
            }

            <router-outlet></router-outlet>
            @if (hasError && !isUnauthorized) {
                <app-error-page></app-error-page>
            }
            @if (isUnauthorized) {
                <app-unauthorized-page></app-unauthorized-page>
            }
        </div>

        <div id="app-footer">
            <app-footer></app-footer>
        </div>
    </div>
</div>

<p-toast
    id="error-messages-anchor"
    position="top-center"
    [key]="toasterPositions.TOP_CENTER"
    [preventOpenDuplicates]="true">
</p-toast>
<p-toast
    id="warning-success-messages-anchor"
    position="bottom-right"
    [key]="toasterPositions.BOTTOM_RIGHT"
    [preventOpenDuplicates]="true">
</p-toast>
